import { Icon } from '@fluentui/react';
import styled from 'styled-components/macro';

export const CardsWrapper = styled.div`
    width: 100%;
    overflow: auto;
    display: flex;
`;
export const LeasingCrossVisitsWidgetWrapper = styled.div``;
